import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from "react-on-screen";

const Data = [
    {
        countNum : 90,
        countTitle: 'Aperturas realizadas',
    },
    {
        countNum : 100,
        countTitle: 'Coaching a dueños',
    },
    {
        countNum : 500,
        countTitle: 'Entrenamientos a staff',
    },
    {
        countNum : 2500,
        countTitle: 'Contrataciones asertivas',
    }
];


const CounterUpFour = ({textALign, counterStyle, column}) => {
    return (
        <div className="row">
            {Data.map((data, index) => (
                <div className={`${column}`} key={index}>
                    <div className={`count-box ${counterStyle} ${textALign}`}>
                        <TrackVisibility once>
                            {({ isVisible }) => isVisible && 
                                <div className="count-number">{isVisible ? <CountUp end={data.countNum} /> : 0}</div>}
                        </TrackVisibility>
                        <h5 className="counter-title">{data.countTitle}</h5>
                    </div>
                </div>
            ))}
        </div>
    )
}
export default CounterUpFour;